import * as React from 'react'
import styled, { ThemeContext } from 'styled-components'

import { t } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

export function InnerFooter({ enableReporting = false }): React.ReactElement {
  const theme = React.useContext(ThemeContext)

  return (
    <Wrapper>
      <Waves fill="none" viewBox="0 0 1357 587">
        <path
          fill={theme?.colors?.primary ?? '#4457B8'}
          fillOpacity=".2"
          fillRule="evenodd"
          d="M864.676 216.41c-63.567 6.879-126.315 13.669-190.619-26.579-33.711-21.1-52.716-45.038-71.635-68.87-16.307-20.541-32.551-41.003-58.095-59.499C453.601-4.229 301.191 1.028 301.191 1.028L14.594 6.093 33.898 80.32l235.155-4.117s186.768-9.78 260.201 35.571c32.285 19.94 46.989 39.953 61.656 59.917 14.448 19.664 28.86 39.281 60.005 58.732 63.87 39.89 124.775 27.99 186.533 15.923 56.797-11.097 114.315-22.335 175.522 6.439 51.37 24.146 98.99 97.586 129.85 145.182 9.08 14.003 16.71 25.769 22.55 33.385 14.1 18.355 32.59 34.773 58.95 47.332 26.37 12.56 87.61 5.642 87.61 5.642l10.86 41.672 33.41-.59-21.1-81.141s-52.66-24.782-83.78-46.468c-23.95-16.688-31.81-23.698-50.01-39.928-5.45-4.862-11.82-10.551-19.84-17.576-13.78-12.075-25.31-22.953-35.93-32.976-31.18-29.417-54.55-51.473-104.14-74.832-60.763-28.624-119.08-22.314-176.724-16.076Z"
          clipRule="evenodd"
        />
        <path
          fill={theme?.colors?.background ?? '#ECEEF8'}
          d="M650.914 230.422c122.609 76.574 234.29-37.7 362.056 22.361 66.48 31.25 126.68 145.069 152.4 178.567 14.1 18.355 32.59 34.773 58.95 47.333 26.37 12.56 87.61 5.641 87.61 5.641l21.09 80.947-1200.992 21.027L.306 80.906l268.746-4.705s186.768-9.78 260.2 35.572c64.087 39.58 58.898 79.45 121.662 118.649Z"
        />
      </Waves>
      {enableReporting && (
        <ReportPageCTA as="span">
          <plume.Link href="mailto:support@ulule.com" kind="secondary" withIcon>
            <plume.glyphs.stroke.Alert size={16} />
            {t('Flag this project')}
          </plume.Link>
        </ReportPageCTA>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  overflow: hidden;
  flex-direction: column-reverse;
  height: 190px;
  justify-content: space-between;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    flex-direction: row;
    height: auto;
  }
`

const Waves = styled.svg`
  bottom: -74px;
  left: -119vw;
  position: relative;
  scale: 5.3;
  width: 250vw;
  z-index: -1;

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    bottom: -90px;
    left: -70px;
    scale: 1.3;
    width: 60%;
  }
`

const ReportPageCTA = styled(plume.styles.copy.S)`
  align-self: center;
  position: relative;

  ${plume.glyphs.stroke.Alert} {
    margin-top: 2px;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    align-self: end;
    bottom: 32px;
    margin-right: auto;
  }
`
